import { ServicesDowntimeAction } from './actions';

import {
 GATEWAY_SERVICES_TIMEOUT_ERROR
} from './types';

type ServicesDowntimeState = {
  isMaintenanceModeOn: boolean
};

const INITIAL_STATE: ServicesDowntimeState = {
  isMaintenanceModeOn: false
};

export const reducer = (
  state = INITIAL_STATE,
  action: ServicesDowntimeAction
): ServicesDowntimeState => {
  switch (action.type) {
      case GATEWAY_SERVICES_TIMEOUT_ERROR:
        return {
          ...state,
          isMaintenanceModeOn: action.payload
        };
      
    default:
      return state;
  }
};